import { isMobileScreen, setPageTitle } from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

function TermsAndConditions() {
  setPageTitle("Terms & Conditions | Legal Terms of Service & Use");
  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span className="">Terms & Conditions</span>
            </li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          <div className="row row-40">
            {isMobileScreen() ? (
              <></>
            ) : (
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
            )}
            <div className="col-md-10">
              <div className="container">
                <h1 className="h3 font-weight-bold mt-2">Terms & Conditions</h1>
                <div className="body-1">
                  By accessing or using this website, you agree to be bound by
                  these Terms & Conditions. Please read them carefully before
                  using our site or services.
                </div>

                <section className="mb-4 mt-4">
                  <h2 className="h4 section-title mb-2">Eligibility</h2>
                  <div className="body-1 mb-2">
                    <div>
                      You must be at least 21 years old to use this website or
                      purchase products.
                    </div>
                    <div>
                      By using this site, you represent and warrant that you
                      meet all eligibility requirements.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Account Registration
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      You may be required to create an account to access certain
                      features.
                    </div>
                    <div>
                      You are responsible for maintaining the confidentiality of
                      your account and password.
                    </div>
                    <div>
                      You agree to provide accurate, current, and complete
                      information during registration.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Orders & Payment</h2>
                  <div className="body-1 mb-2">
                    <div>
                      All orders are subject to acceptance and availability.
                    </div>
                    <div>
                      We reserve the right to refuse or cancel any order at our
                      discretion.
                    </div>
                    <div>
                      Prices and availability are subject to change without
                      notice.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Product Information</h2>
                  <div className="body-1 mb-2">
                    <div>
                      We strive to ensure product descriptions and images are
                      accurate, but we do not warrant that they are error-free.
                    </div>
                    <div>
                      All product use is at your own risk. Please follow all
                      instructions and warnings.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Prohibited Conduct</h2>
                  <div className="body-1 mb-2">
                    <div>
                      You agree not to use the site for any unlawful purpose or
                      in violation of any applicable laws.
                    </div>
                    <div>
                      You may not use the site to harass, abuse, or harm others,
                      or to transmit any harmful or malicious code.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Intellectual Property
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      All content on this site, including text, images, logos,
                      and graphics, is the property of the site owner or its
                      licensors and is protected by copyright and trademark
                      laws.
                    </div>
                    <div>
                      You may not use, reproduce, or distribute any content
                      without prior written permission.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Limitation of Liability
                  </h2>
                  <div className="body-1">
                    To the fullest extent permitted by law, we disclaim all
                    warranties, express or implied, and will not be liable for
                    any damages arising from your use of the site or products.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Indemnification</h2>
                  <div className="body-1">
                    You agree to indemnify and hold harmless the site owner and
                    its affiliates from any claims, damages, or expenses arising
                    from your use of the site or violation of these terms.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Governing Law</h2>
                  <div className="body-1">
                    These Terms & Conditions are governed by the laws of the
                    state in which our business is registered, without regard to
                    its conflict of law principles.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Changes to Terms</h2>
                  <div className="body-1">
                    We reserve the right to update or modify these Terms &
                    Conditions at any time. Changes will be posted on this page
                    with an updated effective date. Your continued use of the
                    site constitutes acceptance of the new terms.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Contact Us</h2>
                  <div className="body-1">
                    If you have any questions about these Terms & Conditions,
                    please contact us at{" "}
                    <strong>{process.env.REACT_APP_SUPPORT_EMAIL}</strong>.
                  </div>
                </section>

                <footer className="mt-5">
                  <div className="font-weight-bold small">
                    *This is an auto-generated policy. Please contact support
                    for any questions.
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsAndConditions;
